// ViewBannerModal.tsx

import React from "react";
import { Modal, Text, Button, Group, TextInput, Textarea } from "@mantine/core";
import { IconPhoto } from "@tabler/icons-react";
import classes from "./view.module.css"; // Use appropriate styles
import { RowDataContactUs } from "./types";

import { formatYYYY_MM_DD_HH_mm } from "../../helper/DateTime";

interface ViewBannerModalProps {
  isOpen: boolean;
  onClose: () => void;
  bannerData: RowDataContactUs;
}

const ViewMessageModal: React.FC<ViewBannerModalProps> = ({
  isOpen,
  onClose,
  bannerData,
}) => {
  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          View Message
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <TextInput label="Fullname:" mb="sm" value={bannerData.fullname} readOnly />

      {/* <Text className={classes.Text}>
        Image <span className={classes.format}>(.jpg, .png)</span>
      </Text>
      <div className={classes.bannerImageContainer}>
        {bannerData.imageSrc ? (
          <img
            src={bannerData.imageSrc}
            alt="Banner Image"
            className={classes.bannerImageSize}
          />
        ) : (
          <p>
            <IconPhoto />
          </p>
        )}
      </div> */}

      <TextInput label="Email:" mb="sm" value={bannerData.email} readOnly />

      <TextInput label="Phone Number:" mb="sm" value={bannerData.phone_number} readOnly />

      <Textarea label="Message:" mb="sm" value={bannerData.message} autosize={true} minRows={4} readOnly/>

      <TextInput label="Submitted Date:" mb="sm" value={formatYYYY_MM_DD_HH_mm(bannerData.createdAt)} readOnly />

      {/* <Group className={classes.buttonBottom}>
        <Button onClick={onClose} className={classes.buttonClose}>
          Close
        </Button>
      </Group> */}
    </Modal>
  );
};

export default ViewMessageModal;
